/** @format */

const template = `
<div class="cu-substitution-popover">
  <p translate="SIS_COMPONENTS.SUBSTITUTIONS.POP_OVER.TEXT_PART_1"></p>
  <common-course-unit validatable-plan="$ctrl.validatablePlan" course-unit="$ctrl.courseUnit"></common-course-unit>

  <p ng-if="$ctrl.substitutingCourseUnits.length == 1" translate="SIS_COMPONENTS.SUBSTITUTIONS.POP_OVER.TEXT_PART_2.SINGULAR"></p>
  <p ng-if="$ctrl.substitutingCourseUnits.length > 1" translate="SIS_COMPONENTS.SUBSTITUTIONS.POP_OVER.TEXT_PART_2.PLURAL"></p>

  <common-course-unit
    ng-repeat="substitutingCourseUnit in $ctrl.substitutingCourseUnits track by substitutingCourseUnit.id"
    validatable-plan="$ctrl.validatablePlan"
    show-notifications="true"
    course-unit="substitutingCourseUnit"
    ><!--
      --><notifications ng-if="::$ctrl.substitutionCredits(substitutingCourseUnit)"
      ><!--
        --><sis-tooltip
        tooltip-text="{{::'SIS_COMPONENTS.SUBSTITUTIONS.CREDITS' | translate: {credits: $ctrl.substitutionCredits(substitutingCourseUnit)} }}"
        ><!--
          --><span class="cu-notification sis-tooltip-trigger-content"
          ><!--
            --><span class="cu-notification-header"><sis-icon icon="info"></sis-icon></span
          ><!--
            --><span
            class="cu-notification-content"
            translate="SIS_COMPONENTS.SUBSTITUTIONS.CREDITS"
            translate-value-credits="{{$ctrl.substitutionCredits(substitutingCourseUnit)}}"></span
          ><!--
          --></span
        ><!--
        --></sis-tooltip
      ><!--
      --></notifications
    >
  </common-course-unit>

  <span ng-if="$ctrl.substitutingCourseUnits.length == 1" class="guidance" translate>SIS_COMPONENTS.SUBSTITUTIONS.POP_OVER.FULL</span>
  <span ng-if="$ctrl.substitutingCourseUnits.length > 1" class="guidance" translate>SIS_COMPONENTS.SUBSTITUTIONS.POP_OVER.TOGETHER</span>
</div>
`;
export default template;
